import axiosInstance from '../axiosInterceptor/axiosInstance'

const getOrg = async (orgId) => {
  const url = `v1/orgs/${orgId}`
  const response = await axiosInstance.get(url)
  return response?.data
}

export default getOrg
